module.exports = __webpack_public_path__ + "static/media/1.698485bb.jpeg";